import React from 'react';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
interface FooterProps {
  onOpenLegal: () => void;
}
export function Footer({
  onOpenLegal
}: FooterProps) {
  return <footer className="bg-[#0A0A0A] border-t-4 border-transparent" style={{
    borderImage: 'linear-gradient(to right, #2563EB, #EF4444) 1'
  }} data-id="element-98">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12" data-id="element-99">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0" data-id="element-100">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center md:items-start" data-id="element-101">
            <img src="https://cdn.magicpatterns.com/uploads/oQVq4BzMykAbXhkeiAseTq/kdlr_talleres.jpg" alt="KDLR Talleres S.L Logo" className="h-16 w-auto object-contain mb-4" data-id="element-102" />
            <p className="text-gray-400 text-sm" data-id="element-103">
              &copy; {new Date().getFullYear()} KDLR Talleres S.L. Todos los
              derechos reservados.
            </p>
          </div>

          {/* Links */}
          <div className="flex space-x-6 text-sm text-gray-400" data-id="element-104">
            <button onClick={onOpenLegal} className="hover:text-white transition-colors" data-id="element-105">
              Aviso legal
            </button>
            <button onClick={onOpenLegal} className="hover:text-white transition-colors" data-id="element-106">
              Condiciones
            </button>
          </div>

          {/* Socials */}
          <div className="flex space-x-4" data-id="element-107">
            <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors" aria-label="Instagram" data-id="element-108">
              <InstagramIcon className="h-6 w-6" data-id="element-109" />
            </a>
            <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors" aria-label="Facebook" data-id="element-110">
              <FacebookIcon className="h-6 w-6" data-id="element-111" />
            </a>
            <a href="#" className="text-gray-400 hover:text-red-400 transition-colors flex items-center justify-center" aria-label="TikTok" data-id="element-112">
              {/* Custom TikTok SVG since lucide doesn't have it */}
              <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24" data-id="element-113">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-114" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}